import { Sparkles, MessagesSquare, ShieldCheck } from "lucide-react"
import { cn } from "@/lib/cn"
import { InfoTooltip } from "@/components/ui/info-tooltip"
import type { TestLabTab } from "@/types/test_lab"

type Props = {
  active: TestLabTab
  onSelect: (tab: TestLabTab) => void
}

const TABS: Array<{ key: TestLabTab; label: string; Icon: typeof Sparkles; sub: string; tip: string }> = [
  { key: "design", label: "Design with Forge", Icon: Sparkles,       sub: "Co-edit the skill with AI",
    tip: "Use AI to write or change this skill." },
  { key: "chat",   label: "Chat",              Icon: MessagesSquare, sub: "Talk to the agent live",
    tip: "Talk to your agent live to see how it acts." },
  { key: "test",   label: "Test",              Icon: ShieldCheck,    sub: "Run scenarios + read transcripts",
    tip: "Run the saved tests against this skill." },
]

export function TestLabTabs({ active, onSelect }: Props) {
  return (
    <div className="flex items-stretch gap-1 border-b border-border">
      {TABS.map((t) => {
        const isActive = active === t.key
        const Icon = t.Icon
        // Forge tab gets the gold accent treatment when active so the
        // "this is the AI surface" cue stays consistent with the Forge
        // CTAs across the app. Other tabs keep the brand-red accent.
        const isForgeTab = t.key === "design"
        return (
          <button
            key={t.key}
            type="button"
            onClick={() => onSelect(t.key)}
            className={cn(
              "flex flex-col items-start gap-0.5 border-b-2 px-4 py-3 text-left transition",
              !isActive && "border-transparent text-app-muted hover:text-app-text",
              isActive && !isForgeTab && "border-brand-red text-app-text",
              isActive && isForgeTab && "forge-tab-active border-b-2",
            )}
          >
            <span className="flex items-center gap-2 text-sm font-semibold">
              <Icon size={14} strokeWidth={1.8} className={cn(isActive && isForgeTab && "forge-icon")} />
              {t.label}
              <InfoTooltip>{t.tip}</InfoTooltip>
            </span>
            <span className="text-[11px] text-app-subtle">{t.sub}</span>
          </button>
        )
      })}
    </div>
  )
}
